import axios from 'axios'
/* import store from '@/store'
import { getHashQuery } from './index.js' */
//"build": "node build/build.js"
axios.defaults.timeout = 8640000000 // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
//axios.defaults.headers.post['Content-Type'] = 'application/json'
//var url='http://api.dms.66km.com.cn/'
var url='https://apidms.dqcarlink.com/'
//axios.defaults.baseURL = process.env.VUE_APP_BASE_API // 配置接口地址
//axios.defaults.baseURL = 'http://api.dms.66km.com.cn/' // 配置接口地址
axios.defaults.baseURL = url // 配置接口地址
// POST传参序列化(添加请求拦截器)
//var epcToken=getHashQuery('token');
//var uid=getHashQuery('uid');
/* var epcToken=store.state.token;
var uid=store.state.uid; */
axios.interceptors.request.use((conf) => {
 // console.log(conf)
  // 在发送请求之前做某件事
    var token= localStorage.getItem('token')
    if (token) {
	   conf.headers['token']=token;
    }

  return conf
}, (error) => {
  //Message.error(error)
  return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
 if (res.data.code === 0) {
  // console.log(res)
   return Promise.resolve(res.data)

 } else {
   alert(res.data.msg)
 }
  return Promise.reject(res.data)

}, (error) => {
 // Message.error(error)
  return Promise.reject(error)
})

export function fetchPost(url, params, options = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, options)
      .then(response => {
        resolve(response)
      }, err => {
        console.log(err)
        reject(err)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}
export function fetchPut(url, params, options = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, params, options)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function fetchGet(url, param,response) {
  return new Promise((resolve, reject) => {
      axios.get(url, { params: param })
        .then(response => {

          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
}
export function fetchGetblob(url, param,response) {
  if(response=='blob'){
   // axios.defaults.responseType='blob'
  }
  return new Promise((resolve, reject) => {
    console.log(response)
    axios.get(url, { params: param, responseType: 'blob' }
   // ,{responseType: 'arraybuffer',},
    )
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}




//export const baseURL = process.env.VUE_APP_BASE_API

export default axios.create()
//export default axios2.create()
